var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<md-toast>\n<div class=\"md-toast-content error\" layout=\"row\" layout-align=\"start start\">\n<div flex=\"grow\">\n<div class=\"title\"><strong>{{toast.content}}</strong></div>\n</div>\n<md-button ng-click=\"toast.hide()\" md-theme=\"error\" class=\"md-primary md-raised\">Ok</md-button>\n</div>\n</md-toast>";
var id1="app/user-controls/error-toast.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/user-controls/error-toast.html
// module id = 695
// module chunks = 0